import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import PageConfigMaxBrandDiscount from 'Pages/config/max-brand-discount';
import PageConfigPasswordRules from 'Pages/config/password-rules';
import PageConfigAppSettings from 'Pages/config/app-settings';

const Home = ({ match }) => (
	<div className="dashboard-wrapper">
		<Switch>
			<Route exact path={`${match.url}/max-brand-discount`} component={ PageConfigMaxBrandDiscount } />
			<Route exact path={`${match.url}/password-rules`} component={ PageConfigPasswordRules } />
			<Route exact path={`${match.url}/app-settings`} component={PageConfigAppSettings} />
			<Redirect to="/error" />
		</Switch>
	</div>
);
export default Home;